import { Static } from '@sinclair/typebox'
import * as geobox from "@jsse/geobox";

export const PositionTB = geobox.Coord2d()
export type PositionT = Static<typeof PositionTB>

export const MultiPolygonTB = geobox.MultiPolygonGeometry()
export type MultiPolygonT = Static<typeof MultiPolygonTB>

export const PointTB = geobox.PointGeometry2d()
export type PointT = Static<typeof PointTB>
